import {
    GET_BONUS,
    GET_STATE_LOADING     
} from "@/views/bonus/store/types/types.js";

const getters = {
    [GET_BONUS]: state => state.bonus,
    [GET_STATE_LOADING]: state => state.loading,
}

export default getters;